export const translationLivechat_da_autoClose = {
  livechatSettingsSectionAutoClose: "Inaktive chats",
  livechatSettingsAutoCloseEnabled: "Luk inaktive chats automatisk",
  livechatSettingsAutoCloseEnabledHelp: "Når kunden ikke svarer på agentens besked.",
  livechatSettingsAutoCloseWarning: "Advar kunden efter",
  livechatSettingsAutoCloseGrace: "Luk chatten efter advarsel",
  livechatSettingsAutoCloseMinutes: "{minutes} min",
  livechatSettingsAutoCloseHour: "1 time",
  livechatSettingsAutoCloseHours: "{hours} timer",
  livechatSettingsAutoCloseNever: "Lukker aldrig, hvis kunden skrev sidst.",
  livechatSettingsAutoCloseTextShow: "Tilpas advarselsbesked",
  livechatSettingsAutoCloseTextHide: "Skjul advarselsbesked",
  livechatSettingsAutoCloseText: "Advarselsbesked",
  livechatSettingsAutoCloseTextPlaceholder:
    "Er du der stadig? Chatten lukker om {minutes} minutter, hvis vi ikke hører fra dig.",
  livechatSettingsAutoCloseTextPlaceholderOne:
    "Er du der stadig? Chatten lukker om 1 minut, hvis vi ikke hører fra dig.",
  livechatSettingsAutoCloseInvalid:
    "Advar efter skal være 1 til 1440 minutter og luk efter advarslen 1 til 120 minutter.",
  livechatAutoCloseCountdown: "Lukker om {time}, medmindre den besøgende svarer",
  livechatAutoCloseCardBadge: "Lukker om {time}",
  livechatAutoCloseKeepOpen: "Hold åben",
  livechatAutoCloseKeepingOpen: "Holder åben…",
  livechatAutoCloseKeptOpen: "Automatisk lukning er slået fra for denne chat",
  livechatAutoCloseKeepOpenFailed: "Chatten kunne ikke holdes åben. Prøv igen.",
  livechatAutoClosedNotice: "Lukket automatisk, fordi den besøgende ikke svarede.",
  livechatAutoClosingNow: "Lukker…",
};
